import React from 'react';
import {useSelector} from 'react-redux';
import DirectoryGroup from './components/directory-group';
import SystemGroup from './components/system-group';
import ContactGroup from './components/contact-group';
import RecentGroup from './components/recent-group';
import './index.css';

const ListOfGroups = () => {

	const directoryGroups = useSelector(state => state.directoryGroupReducer.findDirectoryGroups);

	return (
		<div className={`list-of-groups${directoryGroups && directoryGroups.directoryContactGroupsV4.length === 0 ? ' directory-disabled' : ''}`}>
			{
				(directoryGroups && directoryGroups.directoryContactGroupsV4.length > 0 ) || !directoryGroups
				? <DirectoryGroup/>
				: null
			}
			<RecentGroup/>
			<SystemGroup/>
			<ContactGroup/>
		</div>
	)

};

export default ListOfGroups;
